// hooks/useMeteoStations.js
import { useEffect, useState } from 'react';

import { API_URL } from '../config';
import { authFetch } from '../utils';

const useMeteoStations = () => {
  const [stations, setStations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStations = async () => {
        try {
        const response = await authFetch(`${API_URL}meteos/facility/paterna`);
        if (!response.ok) throw new Error('Error al obtener estaciones');

        const data = await response.json();
        const rawStations = Array.isArray(data) ? data : Object.values(data);

        const stationsArray = rawStations.map((station) => ({
            id: station.meteoId,
            name: station.location?.name || station.name || station.meteoId
        }));

        setStations(stationsArray);
        } catch (err) {
        setError(err.message);
        } finally {
        setLoading(false);
        }
    };

    fetchStations();
    }, []);


  return { stations, loading, error };
};

export default useMeteoStations;
